import css from './css';
import bus from './bus';
import i18n_config, { checkMissingTranslations } from './i18n';
import { AuthGuard } from './routing/guards';
import registrator from './_registrator';
import Screen from './classes/Screen';

import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

import TrustUpPro from './classes/TrustUpPro';
window.TrustUpPro = new TrustUpPro({
    app: process.env.MIX_TRUSTUP_APP_KEY,
    url: process.env.MIX_TRUSTUP_AUTH_URL
});

import TrustUpBase from './apps/trustup-pro-base-js/TrustUpBase';
window.TrustUpBase = new TrustUpBase();
window.TrustUpBase.init();

import Worksite from './apps/trustup-pro-worksite-js/Worksite';
window.Planning = new Planning();
window.Planning.init();

import Planning from './apps/trustup-pro-planning-js/Planning';
window.Worksite = new Worksite();
window.Worksite.init();

/** @type {import('./types/setup').SpaSetup}  */
const setup = {
    css,
    TrustUpPro: window.TrustUpPro,
    config: { 
        services: { flare_key: null },
        i18n: i18n_config
    },
    current_app_key: null,
    current_app: null,
    apps: [],
    auth_url: null,
    app_url: null,
    token: null,
    account: null,
    env: "production",
    store: null,
    i18n: null,
    router: null,
    bus,
    meilisearch: null,

    init({ 
        auth,
        app,
        flare = null,
        store,
        i18n,
        router,
        env = "production"
    })
    {
        this.auth_url = auth;
        this.current_app_key = app;
        this.config.services.flare_key = flare
        this.env = env;
        this.store = store;
        this.i18n = i18n
        this.router = router;
        this.guard = new AuthGuard();
        this.guard.apply();
        
        if (setup.isLocal()) {
            checkMissingTranslations();
            registrator.details();
        }

        return this;
    },

    install(Vue, config = { registration: true })
    {
        Vue.prototype.$spa = this;
        Vue.prototype.$screen = Vue.observable(new Screen);
        Vue.prototype.$moment = (date) => moment(date);

        if (!config.registration) return;

        registrator.register();
    },
    
    getCurrentApp()
    {
        return this.current_app;
    },

    getCurrentAppUrl()
    {
        return (this.current_app && this.current_app.url) ?? null;
    },
    
    isCurrentApp(app_key)
    {
        return this.current_app_key === app_key
    },

    setMeilisearch(meilisearch) {
        this.meilisearch = meilisearch;

        return this;
    },

    setAccount(account)
    {
        this.account = account;
        this.store.dispatch('ACCOUNT/SET', account);

        return this;
    },

    setToken(token)
    {
        this.token = token;
        token
            ?this.store.dispatch('TOKEN/SET', token) 
            :this.store.dispatch('TOKEN/REMOVE');

        return this;
    },

    setApps(apps)
    {
        this.apps = apps;
        this.current_app = this.apps.find(app => app.key === this.current_app_key) ?? null;

        return this;
    },

    setUser(user)
    {
        this.user = user;
        this.store.dispatch('USER/SET', user);
        
        this.setUserLocale(user)
            .setUserInIntercom(user);

        return this;
    },

    setUserLocale(user)
    {
        const { store, i18n } = this;
        const { locale } = user;

        if ( ! locale || ! i18n.availableLocales.includes(locale) ) {
            console.error('Cannot set user locale, it might not be defined or not supported:', locale);
            return this;
        }

        i18n.locale = locale;
        store.dispatch('USER/SET_LOCALE', locale);
        moment.locale(locale);

        return this;
    },

    setUserInIntercom(user)
    {
        const { Intercom } = window
        
        if ( ! Intercom ) {
            return this;
        }

        const { intercomSettings: settings } = window;

        settings.user_id = user.id;
        settings.user_hash = user.intercom_hash;
        settings.name = user.getFullName();
        settings.email = user.email;
        settings.created_at = user.created_at;

        Intercom('update', settings);

        return this;
    },

    startLoading()
    {
        this.store.dispatch('APP/START_LOADING');

        return this;
    },
 
    stopLoading()
    {
        this.store.dispatch('APP/STOP_LOADING');

        return this;
    },

    isLocal()
    {
        return this.env === "local"
    },

    isProduction()
    {
        return this.env === "production";
    }

};

export default setup;